import React from 'react'

export const PinIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.0792 21.9507C12.721 22.298 12.3605 22.6475 12 23C11.6395 22.6475 11.279 22.298 10.9208 21.9507C6.80789 17.9629 3 14.2708 3 9.8C3 4.93989 7.02944 1 12 1C16.9706 1 21 4.93989 21 9.8C21 14.2708 17.1921 17.9629 13.0792 21.9507ZM16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10Z"
			fill="#4A4A4A"
		/>
		<mask
			id="mask0_28610_8890"
			style={{ maskType: 'alpha' }}
			maskUnits="userSpaceOnUse"
			x="3"
			y="1"
			width="18"
			height="22">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.0792 21.9507C12.721 22.298 12.3605 22.6475 12 23C11.6395 22.6475 11.279 22.298 10.9208 21.9507C6.80789 17.9629 3 14.2708 3 9.8C3 4.93989 7.02944 1 12 1C16.9706 1 21 4.93989 21 9.8C21 14.2708 17.1921 17.9629 13.0792 21.9507ZM16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10Z"
				fill="#4A4A4A"
			/>
		</mask>
		<g mask="url(#mask0_28610_8890)">
			<rect x="12" width="13" height="24" fill="#BDBDBD" />
		</g>
	</svg>
)
